import React, { useEffect, useState } from 'react';
import CTAButton from '../Buttons/CTAButton/CTAButton';

const PopupBanner = ({ imageUrl, onClose }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if the banner has been shown in this session
    const hasSeenBanner = sessionStorage.getItem('hasSeenPopupBanner');
    
    if (!hasSeenBanner) {
      // Small delay before showing the banner for better UX
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 500);
      
      return () => clearTimeout(timer);
    }
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    sessionStorage.setItem('hasSeenPopupBanner', 'true');
    if (onClose) onClose();
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };

  if (!isVisible) return null;

  return (
    <div 
      className="fixed inset-0 z-[9999] flex items-center justify-center p-4 animate-fadeIn"
      onClick={handleBackdropClick}
    >
      {/* Backdrop */}
      <div 
        className="fixed inset-0 bg-black/70 backdrop-blur-sm"
        aria-hidden="true"
      />
      
      {/* Modal Content - Optimized for 1:1 aspect ratio */}
      <div 
        className="relative bg-white rounded-2xl shadow-2xl w-full max-w-2xl overflow-hidden animate-scaleIn flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close Button */}
        <button
          onClick={handleClose}
          className="absolute top-4 right-4 z-10 bg-white/90 hover:bg-white text-gray-800 rounded-full p-2 shadow-lg transition-all duration-200 hover:scale-110"
          aria-label="Close popup"
        >
          <svg 
            xmlns="http://www.w3.org/2000/svg" 
            className="h-6 w-6" 
            fill="none" 
            viewBox="0 0 24 24" 
            stroke="currentColor"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={2} 
              d="M6 18L18 6M6 6l12 12" 
            />
          </svg>
        </button>

        {/* Image Container */}
        <div className="relative w-full aspect-square">
          <img
            src={imageUrl}
            alt="Postponed Event Flyer"
            className="w-full h-full object-cover"
            loading="eager"
          />
        </div>

        {/* CTA Section */}
        <div className="bg-gradient-to-br from-gray-50 to-white px-6 py-5 border-t-2 border-Color-Brand/20">
          <p className="text-gray-800 text-sm sm:text-base font-medium font-['Montserrat'] mb-3 text-center">
            Visit our official website for complete event details and registration
          </p>
          <div className="flex justify-center">
            <a 
              href="https://rextro.lk" 
              target="_blank" 
              rel="noopener noreferrer"
              onClick={handleClose}
            >
              <CTAButton 
                text="VISIT REXTRO.LK" 
                url="https://rextro.lk"
                isRainbow={true}
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PopupBanner;
